import { __assign } from "tslib";
export var wrapInSearchResult = function (items, count, rest) {
    if (count === void 0) { count = items.length; }
    if (rest === void 0) { rest = {}; }
    return __assign({ items: items, itemsCount: count }, rest);
};
export var testUtils = {
    $q: null,
    // tslint:disable-next-line:object-literal-shorthand
    wrapInSearchResponse: function (items, count) {
        if (count === void 0) { count = items.length; }
        return {
            items: items,
            itemsCount: count
        };
    },
    emptySearchResponse: function () {
        return testUtils.wrapInSearchResponse([]);
    },
    // tslint:disable-next-line:object-literal-shorthand
    mockAppState: function (extraStates) {
        if (extraStates === void 0) { extraStates = []; }
        angular.mock.module(function ($stateProvider) {
            extraStates
                .concat(['app', 'app.404', 'app.no-permission'])
                .forEach(function (state) { return $stateProvider.state(state, {}); });
        });
    },
    // tslint:disable-next-line:object-literal-shorthand
    mockAppLang: function (lang, supportedLangs) {
        if (supportedLangs === void 0) { supportedLangs = [lang]; }
        angular.mock.module(function ($provide, appConfig) {
            var configCopy = angular.copy(appConfig);
            configCopy.lang = lang;
            $provide.constant('appConfig', configCopy);
            $provide.constant('supportedLangs', supportedLangs);
            // temp
            $provide.constant('TENANT_ID', '12345678-1234-1234-1234-1234567890ab');
        });
    },
    // tslint:disable-next-line:object-literal-shorthand
    extendAppConfig: function (extendendConfig) {
        angular.mock.module(function ($provide, appConfig) {
            var configCopy = angular.extend({}, appConfig, extendendConfig);
            $provide.constant('appConfig', configCopy);
        });
    },
    // tslint:disable-next-line:object-literal-shorthand
    mockBranding: function (extendendBrandingConfig) {
        angular.mock.module(function ($provide, brandingConfig) {
            var configCopy = angular.extend({}, brandingConfig, extendendBrandingConfig);
            $provide.constant('brandingConfig', configCopy);
        });
    }
};
//# sourceMappingURL=test-utils.js.map